export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9034.6f8863e4.jpg";